/* eslint-disable no-extend-native */
// Extending the String Prototype

String.prototype.removeSpace = function removeSpace() {
  return this.replace(/\s/g, '')
}

String.prototype.toCamelCase = function toCamelCase() {
  return `${this.charAt(0).toLowerCase()}${this.slice(1)}`
}

String.prototype.capitalize = function capitalize() {
  return `${this.charAt(0).toUpperCase()}${this.slice(1)}`
}

export {}
